const _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"ed2d501de2850da269e335b595be65be60823b5e"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["web-frontend@codingal-inc"]={id:"ed2d501de2850da269e335b595be65be60823b5e"};
      